import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { UserContext } from '../../context/User';
import { useLocation, useHistory } from "react-router-dom";
import { purchaseGet } from '../../api';
import Loading from '../Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';
import SinglePageItemText from '../SinglePageItemTypes/SinglePageItemText';
import SinglePageItemArray from '../SinglePageItemTypes/SinglePageItemArray';

const B2BSingle = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const id = query.get("id");
  const [b2bData, setb2bData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  useEffect(() => {
    if (id) {
      setLoading(true);
      purchaseGet({id})
        .then(response => {
          setb2bData(response.data);
          setLoading(false);
        })
        .catch(error => {
          handleDefaultStatusCodes(error.response.status);
          setLoading(false);
        })
    }
  }, [])

  return (
    <section className="section-spaces">
       <Container>
        <Row>
          <Col>
            <div className="single-page-wrap">
              <h3>{b2bData.name}</h3>
              <SinglePageItemText 
                title="Description"
                value={b2bData.description}
              />
              <SinglePageItemText 
                title="Agency Name"
                value={b2bData.agency_name}
              />
              <SinglePageItemText 
                title="Name of Requestor"
                value={b2bData.requestor_name}
              />
              <SinglePageItemText 
                title="Date Required"
                value={b2bData.required_date}
              />
              <SinglePageItemText 
                title="Date Requested"
                value={b2bData.closing_date}
              />
               <SinglePageItemText 
                title="Primary NAICS"
                value={b2bData.naics}
              />
              <SinglePageItemText 
                title="Part Number/Stock Number"
                value={b2bData.part_number}
              />
              <SinglePageItemText 
                title="Quantity"
                value={b2bData.quantity}
              />
              <SinglePageItemText 
                title="City/Installation"
                value={b2bData.city}
              />
              <SinglePageItemText
                title="State"
                value={b2bData.state}
              />
              <SinglePageItemText 
                title="ZIP Code"
                value={b2bData.zip}
              />
              <SinglePageItemArray 
                title="Business Type"
                type="pm"
                value={b2bData.setaside_code}
              />
              <SinglePageItemText 
                title="Comments"
                value={b2bData.comment}
              />
              <div className="single-page-item align-items-center">
                <h4>
                 Aplicable Link
                </h4>
                <a className="btnSizes filledBtn" target="_blank" rel="noreferrer" href={b2bData.link}>View Opportunity</a>
              </div>
            </div>
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>    
    </section>
  )
}

export default B2BSingle;